<template>
    <div v-if="cardList.length>0">
        <div v-for="({componentIndex,componentNeedData},index) in cardComponentList" :key="index">
            <component :is="componentIndex" :data="componentNeedData" v-if="(componentNeedData.items&&componentNeedData.items.length>0 || componentNeedData.cardType == 40601)" class="list-page"></component>
        </div>
        <div class="bottom-footer" v-if="cardList.length>1">没有更多内容了</div>
    </div>
</template>

<script>
    import Api from "../../service/api";
    import Cookies from 'js-cookie'
    import listJson from "@/constants/mock/list"
    import global from '../../components/Global';
    import pv from '../../service/pingback/pv';

    export default {
        data() {
            return {
                pageData: {},
                cardList: [],
                cardComponentList: []
            }
        },

        watch: {
            '$route.params.pageId'(param) {
                // let param = this.$route.params.pageId;
                this.cardComponentList = [];
                this.loadData(param)
               setTimeout(() => {
                   document.getElementById('app').scrollTop = 0
               }, 0)
            }
        },

        methods: {
             async getListData(pageKey) {
                 let testJson = await Api.read(pageKey, 'list');
                 // let testJson = listJson.data;
                 this.pageData = testJson&&testJson.pages[0];
                 this.cardList = this.pageData&&this.pageData.cards || [];   
                this.cardComponentList = this.$renderCardComponentList(this.cardList);
                 let docTitle = this.pageData && this.pageData.showData && this.pageData.showData.texts && this.pageData.showData.texts[0].text || '知识店铺';
                 this.$store.dispatch('category/setNvTitle', '知识店铺');
                 document.title = '爱奇艺知识';
                 const channel = this.$getParameterByName("social_platform")
                 if (channel) {
                     global.channel = channel;
                 }

                 let homePageUrl = testJson && testJson.extend && testJson.extend.homePageUrl;
                 if (homePageUrl) {
                     Cookies.set('homePageUrl', homePageUrl+`&social_platform=${global.channel}`);
                 }
                 Cookies.set('lastPage', location.href);
                 let qiyiId = testJson && testJson.extend && testJson.extend.qiyiId;
                 if (qiyiId) {
                     Cookies.set('qiyiId',qiyiId)
                 }

                 let shopTitle = this.cardList && this.cardList[0]
                     && this.cardList[0].items && this.cardList[0].items[0]
                     && this.cardList[0].items[0].showData
                     && this.cardList[0].items[0].showData.texts
                     && this.cardList[0].items[0].showData.texts[0]
                     && this.cardList[0].items[0].showData.texts[0].text || '知识店铺';
                 let shopId = testJson && testJson.storeInfo && testJson.storeInfo.key || " ";
                 Cookies.set('shopTitle', shopId);

                 window.pageTitle = docTitle
                 window.storeInfo = testJson.storeInfo

                 let opt = {
                     rpage: `knowledge_h5_shop_${shopId}_${docTitle}`,
                     shop_id: shopId,
                     v: 1
                 }
                 pv.send(opt);
             },

            loadData(id) {
                if (id) {
                    let arr = id.split('.html');
                    this.getListData(arr[0]);
                }
                this.$store.dispatch('category/home', false);
            }
        },

        created() {
            let param = this.$route.params.pageId;
            this.cardComponentList = [];
            this.loadData(param)
         }
    }
</script>

<style scoped>
    .list-page-all{
        margin-top:20px;
    }
</style>
